import React from 'react';
import UserAvatar from './UserAvatar';
import { useSelector } from 'react-redux';
import { currentUserSelector } from '../../../store/profile/profile.store';

export default function MyAvatar(props) {
	const currentUser = useSelector(currentUserSelector);
	return <UserAvatar {...props} src={currentUser.avatar} />;
}
